
import './_vportal.js';

window.addEventListener("load", function () {
    var swiper = new Swiper(".swiper-banner", {
        autoplay: {
            delay: 5000,
        },
      pagination: {
        el: ".swiper-banner-pagination"
  
      },
    });

    $(".news").each(function () {
        var postsTag = "#" + $(this).attr("id");
        console.log(postsTag);
        $().vPortal({
            container: postsTag,
            el: {
                tabContainer: '.news-tabs > a',
                resultContainer: '.news-list',
                viewAll: '.viewAll',
            },
            paginationOptions: {
            }
        });

    });


});